import { render } from "./ShowPatient.vue?vue&type=template&id=2cb9eea5&scoped=true&ts=true"
import script from "./ShowPatient.vue?vue&type=script&lang=ts"
export * from "./ShowPatient.vue?vue&type=script&lang=ts"

import "./ShowPatient.vue?vue&type=style&index=0&id=2cb9eea5&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cb9eea5"]])

export default __exports__